import React from 'react'
import styled from 'styled-components'

const StyledInfoCard = styled.div`
  padding: 12px 16px 0 16px;
  border: 2px solid ${props => props.theme['neutral-300']};
  border-radius: 16px;
  margin-bottom: 12px;
`

const StyledInfoCardItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 24px;
  align-items: center;
`

const StyledInfoCardItemLabel = styled.div`
  color: ${props => props.theme['neutral-400']};
  span {
    font-size: 12px;
  }
`

const StyledInfoCardItemContent = styled.div`
  color: ${props => props.theme['neutral-400']};
`

export const InfoCard: React.FC<{
  style?: React.CSSProperties
  children: React.ReactNode
}> = ({ style, children }) => {
  return <StyledInfoCard style={style}>{children}</StyledInfoCard>
}

export const InfoCardItem: React.FC<{
  label: React.ReactNode
  onClick?: () => void
  children: React.ReactNode
}> = ({ label, onClick, children }) => {
  return (
    <StyledInfoCardItem onClick={() => onClick?.()}>
      <StyledInfoCardItemLabel>{label}</StyledInfoCardItemLabel>
      <StyledInfoCardItemContent>{children}</StyledInfoCardItemContent>
    </StyledInfoCardItem>
  )
}
